<template>
    <div id="single-choice-settings">
        <div class="form-field">
            <label for="field-label" class="form-label">{{ $t("form.fieldLabel") }}</label>
            <input
                type="text"
                id="field-label"
                class="form-input"
                placeholder="Bir soru girin"
                v-model="fieldLabel"
                @input="setFieldLabel(fieldLabel)"
            >
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.labelAlignment") }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: labelAlign === 'left' }" @click="setlabelAlign('left')">{{ $t("form.left") }}
                </button>
                <button class="button" :class="{ active: labelAlign === 'right' }" @click="setlabelAlign('right')">{{ $t("form.right") }}
                </button>
                <button class="button" :class="{ active: labelAlign === 'top' }" @click="setlabelAlign('top')">{{ $t("form.top") }}
                </button>
            </div>
            <small class="form-description">{{ $t("form.chooseLabelAlignment") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">{{ $t("form.required") }}</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: isRequired }"
                      @click="toggleRequired">{{ isRequired ? $t("chatWindow.open") : $t("chatWindow.closed") }}</span>
            </div>
            <small class="form-description">{{ $t("form.fieldEmptyError") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">Görünürlük</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: visibility }"
                      @click="toggleVisibility">{{ visibility ? "Görünür" : "Gizli" }}</span>
            </div>
            <small class="form-description">Bu alanın form üzerinde görünür olup olmayacağını belirler</small>
        </div>

        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="singleChoice"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>

        <div class="form-field" v-if="items && items.length > 0">
            <label class="form-label">Default Seçim</label>
            <div class="default-selection-list">
                <div v-for="(option, index) in items" :key="index" class="default-option-item">
                    <input 
                        type="radio" 
                        :id="'default-option-' + index" 
                        name="defaultSelection" 
                        :value="option"
                        :checked="defaultValue === option"
                        @change="setDefaultValue(option)"
                    >
                    <label :for="'default-option-' + index">{{ option }}</label>
                </div>
                <div class="default-option-item">
                    <input 
                        type="radio" 
                        id="default-option-none" 
                        name="defaultSelection" 
                        :value="null"
                        :checked="defaultValue === null"
                        @change="setDefaultValue(null)"
                    >
                    <label for="default-option-none">Seçim Yok</label>
                </div>
            </div>
            <small class="form-description">Form açıldığında varsayılan olarak seçili gelecek seçeneği belirleyin</small>
        </div>

        <!--        <div class="form-field">-->
        <!--            <label class="form-label">Alanı Kopyala</label>-->
        <!--            <button class="duplicate-button" @click="duplicateField">DUPLICATE</button>-->
        <!--            <small class="form-description">Bu alanın tüm kayıtlı ayarlarını koruyarak bir kopyasını oluşturun</small>-->
        <!--        </div>-->
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "SingleChoiceSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldLabel: this.item.singleChoice.fieldLabel,
            labelAlign: this.item.singleChoice.align,
            isRequired: this.item.singleChoice.isRequired,
            items: this.item.singleChoice.items || [],
            visibility: this.item.visibility !== undefined ? this.item.visibility : true,
            slug: this.item.slug || '',
            defaultValue: (this.item.singleChoice.defaultValues && Array.isArray(this.item.singleChoice.defaultValues) && this.item.singleChoice.defaultValues.length > 0) ? this.item.singleChoice.defaultValues[0] : null,
            updateTimer: null,
        };
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        setlabelAlign(labelAlign) {
            this.labelAlign = labelAlign;
            this.$emit("update-label-align-single-choice", labelAlign);
            this.updateField();
        },
        toggleRequired() {
            this.isRequired = !this.isRequired;
            this.updateField();
            this.$emit('update-required', this.isRequired);
        },
        toggleVisibility() {
            this.visibility = !this.visibility;
            this.updateField();
            this.$emit('update-visibility', this.visibility);
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.updateField();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        duplicateField() {
            console.log("Field duplicated");
        },
        setFieldLabel(label) {
            this.fieldLabel = label;
            this.$emit("update-field-label-single-choice", label);
            this.updateField();
        },
        setDefaultValue(value) {
            this.defaultValue = value;
            this.updateField();
        },
        updateField() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    visibility: self.visibility,
                    slug: self.slug,
                    singleChoice: {
                        fieldLabel: self.fieldLabel,
                        align: self.labelAlign,
                        isRequired: self.isRequired,
                        items: self.items,
                        defaultValues: self.defaultValue ? [self.defaultValue] : []
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
            }, 800);
        },
    },
    watch: {
        item: {
            handler: function (val) {
                if (!val || !val.singleChoice) { return; }
                this.fieldLabel = val.singleChoice.fieldLabel;
                this.labelAlign = val.singleChoice.align;
                this.isRequired = val.singleChoice.isRequired;
                this.items = val.singleChoice.items || [];
                this.visibility = typeof val.visibility !== 'undefined' ? val.visibility : this.visibility;
                this.slug = val.slug || '';
                this.defaultValue = (val.singleChoice.defaultValues && Array.isArray(val.singleChoice.defaultValues) && val.singleChoice.defaultValues.length > 0) ? val.singleChoice.defaultValues[0] : null;
            },
            deep: true,
            immediate: false,
        },
        'item.singleChoice.fieldLabel': function (v) { this.fieldLabel = v; },
        'item.singleChoice.align': function (v) { this.labelAlign = v; },
        'item.singleChoice.isRequired': function (v) { this.isRequired = v; },
        'item.singleChoice.items': function (v) { this.items = v || []; },
        'item.singleChoice.defaultValues': function (v) { this.defaultValue = (v && Array.isArray(v) && v.length > 0) ? v[0] : null; },
        'item.visibility': function (v) { this.visibility = v; },
        'item.slug': function (v) { this.slug = v || ''; },
    },
};
</script>

<style lang="scss" scoped>
#single-choice-settings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .button-group {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;

            .button {
                flex: 1;
                padding: 6px 8px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;

                &.active {
                    background-color: #f26a52;
                    color: #ffffff;
                    border-color: #f26a52;
                    box-shadow: 0 1px 3px rgba(242, 106, 82, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 8px 16px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;
                min-width: 80px;

                &.active {
                    background-color: #10b981;
                    color: #ffffff;
                    border-color: #10b981;
                    box-shadow: 0 1px 3px rgba(16, 185, 129, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .default-selection-list {
            display: flex;
            flex-direction: column;
            gap: 8px;
            max-height: 200px;
            overflow-y: auto;
            padding: 8px;
            background-color: #f9fafb;
            border-radius: 6px;
            border: 1px solid #e5e7eb;

            .default-option-item {
                display: flex;
                align-items: center;
                padding: 6px 8px;
                border-radius: 4px;
                transition: background-color 0.2s ease;

                &:hover {
                    background-color: #ffffff;
                }

                input[type="radio"] {
                    margin-right: 8px;
                    cursor: pointer;
                    accent-color: #f26a52;
                }

                label {
                    flex: 1;
                    cursor: pointer;
                    font-size: 0.875rem;
                    color: #374151;
                    margin-bottom: 0 !important;
                }
            }
        }
    }
}
</style>
